import {
	container,
	whiteColor,
	grayColor,
	hexToRgb,
	blackColor,
} from "assets/jss/material-kit-pro-react.js";

const modalStyle = (theme) => ({
	container,
	modalRoot: {
		overflow: "auto",
		display: "block",
	},
	modal: {
		[theme.breakpoints.up("sm")]: {
			maxWidth: "1200px",
			margin: "auto",
			textAlign: "center",
		},
		borderRadius: "6px",
		overflow: "visible",
		maxHeight: "unset",
		width: "100%",
		marginTop: "130px !important",
	},
	modalHeader: {
		borderBottom: "none",
		paddingTop: "24px",
		paddingRight: "24px",
		paddingBottom: "0",
		paddingLeft: "24px",
		minHeight: "16.43px",
	},
	paragraph: {
		textAlign: "left",
		fontSize: "1rem",
		fontWeight: "400",
		lineHeight: "1.5em",
		paddingLeft: "2rem",
		paddingRight: "2rem",
	},
	paragraphBold: {
		textAlign: "justify",
		fontSize: "1rem",
		fontWeight: "800",
		lineHeight: "1.5em",
		paddingBottom: "1rem",
		paddingTop: "1rem",
		paddingLeft: "2rem",
		paddingRight: "2rem",
	},
	paragraphTitle: {
		textAlign: "left",
		fontSize: "1.2rem",
		fontWeight: "800",
		lineHeight: "1.5em",
		paddingBottom: "1rem",
		paddingLeft: "2rem",
		paddingRight: "2rem",
	},
	modalTitle: {
		fontSize: "16px",
		margin: "0",
		lineHeight: "1.5",
		fontFamily: "Rubik-Medium",
		fontWeight: "500",
	},
	modelTitleImg: {
		height: "40% !important",
		width: "40% !important",
	},
	headerLayout: {
		padding: "1.875rem 0px",
		"& $card": {
			marginTop: "30px",
		},
		"& form": { margin: "0px" },
		"& $formFix": { paddingTop: "0px" },
		"&$subscribeLineImage:after": {
			position: "absolute",
			zIndex: 1,
			width: "100%",
			height: "100%",
			display: "block",
			left: 0,
			top: 0,
			content: "''",
			backgroundColor: "rgba(" + hexToRgb(blackColor) + ",0.66)",
		},
	},
	subscribeLineImage: {
		position: "relative",
		backgroundPosition: "top center",
		backgroundSize: "cover",
		"& $container": {
			zIndex: 2,
			position: "relative",
		},
		"& $title": {
			color: whiteColor,
		},
		"& $description": {
			color: grayColor[0],
		},
	},
	dialogTitle: {
		margin: "0px",
		padding: "10px",
		borderTopLeftRadius: "6px",
		borderTopRightRadius: "6px",
		fontSize: "1.325rem",
		fontFamily: "Rubik-Medium",
		color: "#072A40",
		background: " linear-gradient(90deg,#F9F7F0 13%, #F9F7F0 99%)",
	},
	modalCloseButton: {
		"&, &:hover": {
			color: grayColor[0],
		},
		"&:hover": {
			opacity: "1",
		},
		cursor: "pointer",
		padding: "1rem",
		margin: "-1rem -1rem -1rem auto",
		backgroundColor: "transparent",
		border: "0",
		WebkitAppearance: "none",
		float: "right",
		fontSize: "1.5rem",
		fontWeight: "500",
		lineHeight: "1",
		textShadow: "0 1px 0 " + whiteColor,
		opacity: ".5",
	},
	modalSwitchProfileCloseButton: {
		"&, &:hover": {
			color: grayColor[0],
		},
		"&:hover": {
			opacity: "1",
		},
		cursor: "pointer",
		padding: "2rem",
		margin: "-1rem -1rem -1rem auto",
		backgroundColor: "transparent",
		border: "0",
		WebkitAppearance: "none",
		float: "right",
		fontSize: "1.5rem",
		fontWeight: "500",
		lineHeight: "1",
		textShadow: "0 1px 0 " + whiteColor,
		opacity: ".5",
	},
	modalClose: {
		width: "16px",
		height: "16px",
	},
	modalBody: {
		paddingTop: "24px",
		paddingRight: "24px",
		paddingBottom: "16px",
		paddingLeft: "24px",
		position: "relative",
		overflow: "visible",
	},
	modalFooter: {
		padding: "15px",
		textAlign: "right",
		paddingTop: "0",
		margin: "0",
	},
	modalFooterCenter: {
		marginLeft: "auto",
		marginRight: "auto",
	},
	instructionNoticeModal: {
		marginBottom: "25px",
	},
	imageNoticeModal: {
		maxWidth: "150px",
	},
	modalLarge: {
		[theme.breakpoints.up("md")]: {
			maxWidth: "800px",
		},
	},
	modalSmall: {
		[theme.breakpoints.up("sm")]: {
			width: "500px",
			margin: "auto",
		},
		margin: "0 auto",
	},
	modalSmallBody: {
		marginTop: "20px",
	},
	modalSmallFooterFirstButton: {
		margin: "0",
		paddingLeft: "16px",
		paddingRight: "16px",
		width: "auto",
	},
	modalSmallFooterSecondButton: {
		marginBottom: "0",
		marginLeft: "5px",
	},
	modalLogin: {
		maxWidth: "360px",
		overflowY: "visible",
		width: "100%",
		"& $modalCloseButton": {
			color: whiteColor,
			top: "-10px",
			right: "10px",
			textShadow: "none",
			position: "relative",
		},
		"& $modalHeader": {
			borderBottom: "none",
			paddingTop: "24px",
			paddingRight: "24px",
			paddingBottom: "0",
			paddingLeft: "24px",
		},
		"& $modalBody": {
			paddingBottom: "0",
			paddingTop: "0",
		},
		"& $modalFooter": {
			paddingBottom: "0",
			paddingTop: "0",
		},
	},
	modalLoginCard: {
		marginBottom: "0",
		margin: "0",
		"& $modalHeader": {
			paddingTop: "0",
		},
	},
	modalSignup: {
		maxWidth: "900px",
		width: "100%",
		"& $modalHeader": {
			paddingTop: "0",
		},
		"& $modalTitle": {
			textAlign: "center",
			width: "100%",
			marginTop: "0.625rem",
		},
		"& $modalBody": {
			paddingBottom: "0",
			paddingTop: "0",
		},
	},
	modalSignupCard: {
		padding: "40px 0",
		margin: "0",
	},
	loading: {
		position: "absolute",
		zIndex: "100",
	},
	opacity: {
		opacity: "0.5",
	},
	updateAccountModal: {
		maxWidth: "1000px",
		"& $modalHeader": {
			paddingTop: "0",
			marginTop: "0.625rem",
			marginBottom: "0.625rem",
		},
		"& $modalTitle": {
			textAlign: "left",
			width: "100%",
			fontWeight: "500",
		},
		"& $modalBody": {
			paddingBottom: "0",
			paddingTop: "0",
		},
	},
	updateSubscriptionModal: {
		maxWidth: "700px",
		"& $modalHeader": {
			paddingTop: "0",
			marginTop: "0.625rem",
			marginBottom: "0.625rem",
		},
		"& $modalTitle": {
			textAlign: "left",
			width: "100%",
			fontWeight: "500",
		},
		"& $modalBody": {
			paddingBottom: "0",
			paddingTop: "0",
		},
	},
	createCustomerModal: {
		maxWidth: "1000px",
		"& $modalHeader": {
			paddingTop: "0.625rem",
			// marginTop: "0.625rem",
			// marginBottom: "0.625rem",
		},
		"& $modalTitle": {
			textAlign: "left",
			width: "100%",
			fontWeight: "500",
		},
		"& $modalBody": {
			paddingBottom: "0",
			paddingTop: "0",
		},
	},
	switchProfileModal: {
		maxWidth: "700px",
		"& $modalHeader": {
			paddingTop: "0",
		},
		"& $modalTitle": {
			textAlign: "left",
			width: "100%",
			fontWeight: "500",
			paddingTop: "10px",
		},
		"& $modalBody": {
			paddingBottom: "0",
			paddingTop: "0",
		},
	},
});

export default modalStyle;
